import React, { forwardRef } from "react"

import { css } from "@jsUtils"
import { CONSTANTS } from "@data"

import { Circle } from "@shared"

import Styles from "./button.module.scss"

const { SUBMIT } = CONSTANTS

/**
 * Horizontal button with fully rounded corners, can have nested CTA Circle button
 * @param {object} props - react props
 * @param {object} props.submitProps - has a submit action (or not)
 * @param {COLORS.BLUE|COLORS.FLURO|COLORS.WORKS|COLORS.ALERT} props.color - circle color. . If specified, affects all states.
 * @param {typeof GRADIENTS | undefined} props.hoverColor - Optional, affects hover only (used in special cases like ContactForm where base color isn't defined)
 * @param {string} props.theme - background color theme (light/dark)
 * @param {boolean} props.filled - filled
 * @param {string} props.size - button size
 * @param {string} props.type - button type
 * @param {function} props.onClick - function to trigger on click
 * @param {object} props.children - child components
 * @param {string} props.className - class name
 * @param {object} props.dataProps - data properties injected by the Analytics HOC
 */

const Button = forwardRef((props, ref) => {
  const {
    submitProps = false,
    displayCTA = false,
    color,
    hoverColor,
    theme,
    size,
    children,
    className,
    onClick,
    type,
    filled,
    dataProps
  } = props
  const { disableButton, submitDone } = submitProps
  return (
    <button
      {...dataProps}
      ref={ref}
      disabled={disableButton}
      type={type || "button"} // eslint-disable-line
      className={css(
        Styles.button,
        color && Styles[color],
        hoverColor && Styles[`hover_${hoverColor}`],
        theme && Styles[`theme_${theme}`],
        size && Styles[size],
        filled && Styles.filled,
        className
      )}
      onClick={e => {
        if (onClick) {
          onClick(e)
        }
      }}
    >
      <span className={Styles.copy}>{children}</span>
      {displayCTA && (
        <Circle
          className={css(Styles.ctaButton, Styles.circleButton)}
          color={color === "alert" ? color : filled ? "white" : color}
          size="small"
          whiteOutlinedHover
          theme={theme}
          content={
            submitDone === SUBMIT.BUSY
              ? "busy"
              : submitDone === SUBMIT.SUCCESS
              ? "check"
              : "chevron"
          }
        />
      )}
    </button>
  )
})

export default Button
